import React from "react";
import { Row, Col, Dropdown } from "antd";
import UsersIcon from "../../../../../assets/svgs/users";
import FileIcon from "../../../../../assets/svgs/file2";
import ChatIcon from "../../../../../assets/svgs/chat";
import { MoreVert } from "@mui/icons-material";

const LeadsCard = ({ data = [], editHandler, deleteHandler }) => {
  // HELPERS
  const generateMenuItems = (data) => {
    const menuItems = [
      {
        key: "1",
        label: "Edit",
        onClick: (e) => {
          e.domEvent.stopPropagation();
          editHandler(data);
        },
      },
      {
        key: "2",
        label: "Delete",
        onClick: (e) => {
          e.domEvent.stopPropagation();
          deleteHandler(data);
        },
        danger: true,
      },
    ];
    return menuItems;
  };

  return (
    <Row gutter={[16, 16]}>
      {data.map((d, i) => (
        <Col key={i} xs={24} lg={6}>
          <div key={i} className="leads-communication-card">
            <button className="action-btn">
              <Dropdown
                menu={{
                  items: generateMenuItems(d),
                }}
                trigger={["click"]}
                placement="bottomLeft"
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              >
                <span className="action">
                  <MoreVert />
                </span>
              </Dropdown>
            </button>
            <div className="thumb">
              {d.icon == "users" && <UsersIcon />}
              {d.icon == "file" && <FileIcon />}
              {d.icon == "chat" && <ChatIcon />}
            </div>
            <div className="details">
              <h2>{d.value}</h2>
              <h4>{d.title}</h4>
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default LeadsCard;
